//
import Model from '@/models/Model'

/**
 * This class describes a customer credit.
 * @class ACustomerCredit (name)
 */
export default class ACustomerCredit extends Model {

	/**
	 * { function_description }
	 * @return {string} 
	 */
  resource() {
    return 'customer_credit'
  }
}
